import { getRouteParamAsString } from '@fabric-app/utils/url/routing';
import { useRouter } from '@fabric-app/compat';
import { useRef, useEffect } from 'react';
import { isNumber } from '@fabric-app/utils/guards';

const useRoutePParamChange = (args) => {
  const onParamChangeRef = useRef(args.onParamChange);
  onParamChangeRef.current = args.onParamChange;
  const router = useRouter();
  const [p] = getRouteParamAsString(router.query, [
    "p"
  ]);
  useEffect(() => {
    if (!args.enabled) return;
    const page = Math.floor(Number(p));
    if (page && isNumber(page)) {
      onParamChangeRef.current(page);
    }
  }, [
    p,
    args.enabled
  ]);
};

export { useRoutePParamChange };
//# sourceMappingURL=useRoutePParamChange.js.map
